export default __webpack_public_path__ + "static/media/coresanscr85it-webfont.96643126.woff2";